import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.stepWhatHappened.sectionTitle',
    defaultMessage: 'Section 2 - What Happened',
  },
  dateOfEvent: {
    id: 'fastCover.stepWhatHappened.dateOfEvent',
    defaultMessage: 'Date of Event',
  },
  timeOfEvent: {
    id: 'fastCover.stepWhatHappened.timeOfEvent',
    defaultMessage: 'Time of Event',
  },
  country: {
    id: 'fastCover.stepWhatHappened.country',
    defaultMessage: 'Country',
  },
  city: {
    id: 'fastCover.stepWhatHappened.city',
    defaultMessage: 'City',
  },
  incidentReportedTo: {
    id: 'fastCover.stepWhatHappened.incidentReportedTo',
    defaultMessage: 'Incident Reported To',
  },
  storyEvent: {
    id: 'fastCover.stepWhatHappened.storyEvent',
    defaultMessage: VARS.MESSAGE.stepWhatHappened.storyEvent,
  },
  tellUsWhatHappened: {
    id: 'fastCover.stepWhatHappened.tellUsWhatHappened',
    defaultMessage: 'Tell us what happened',
  },
  pleaseDescribeWhatIsBeingClaimedOrWhatHappenedInDetail: {
    id: 'fastCover.stepWhatHappened.pleaseDescribeWhatIsBeingClaimedOrWhatHappenedInDetail',
    defaultMessage: 'Please describe what is being claimed or what happened in detail',
  },
  tellUsWhatHappenedTooltip: {
    id: 'fastCover.stepWhatHappened.tellUsWhatHappenedTooltip',
    defaultMessage: 'Tell us what happened that caused this claim. Describe the events leading up to it, what exactly happened, who was involved, and what occurred after the event. You will have the opportunity to enter specific expense amounts later on. Note that each claim (such as this one) should include all your losses relating to the event that caused the claim. Separate events require separate claims to be lodged. ',
  },
  totalAmount: {
    id: 'fastCover.stepWhatHappened.totalAmount',
    defaultMessage:
      'What is the total amount you are claiming in Australian Dollars?',
  },
  isClaimDueToInjuryOrIllness: {
    id: 'fastCover.stepWhatHappened.isClaimDueToInjuryOrIllness',
    defaultMessage: "Is your claim due to someone's injury or illness?",
  },
  title: {
    id: 'fastCover.stepWhatHappened.title',
    defaultMessage: 'Title',
  },
  firstName: {
    id: 'fastCover.stepWhatHappened.firstName',
    defaultMessage: 'First Name(s)',
  },
  surName: {
    id: 'fastCover.stepWhatHappened.surName',
    defaultMessage: 'Surname',
  },
  dateOfBirth: {
    id: 'fastCover.stepWhatHappened.dateOfBirth',
    defaultMessage: 'Date of Birth',
  },
  relationshipToYou: {
    id: 'fastCover.stepWhatHappened.relationshipToYou',
    defaultMessage: 'Relationship to you',
  },
  dateYouFirstBecomeAware: {
    id: 'fastCover.stepWhatHappened.dateYouFirstBecomeAware',
    defaultMessage:
      'What date did you first become aware of their injury or illness?',
  },
  injuryOrIllnessOccorredBefore: {
    id: 'fastCover.stepWhatHappened.injuryOrIllnessOccorredBefore',
    defaultMessage: 'Has this injury or illness occurred before?',
  },
  yes: {
    id: 'fastCover.stepWhatHappened.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.stepWhatHappened.no',
    defaultMessage: 'No',
  },
  detailOfMedicalCondition: {
    id: 'fastCover.stepWhatHappened.detailOfMedicalCondition',
    defaultMessage:
      'Please tell us details of the medical condition and the date of diagnosis',
  },
  note: {
    id: 'fastCover.stepWhatHappened.note',
    defaultMessage:
      'Please note that for all claims due to a medical reason, we may need the person suffering the illness or injury to complete a Medical Authority Form and the usual doctor of the ill/injured person to complete a Medical Certificate Form.',
  },
  isRequired: {
    id: 'fastCover.stepWhatHappened.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  checkEventDate: {
    id: 'fastCover.stepWhatHappened.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },
  checkEventTime: {
    id: 'fastCover.stepWhatHappened.checkEventTime',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },
  dateBookedTrip: {
    id: 'fastCover.stepWhatHappened.dateBookedTrip',
    defaultMessage: 'Date I booked my trip',
  },
  dateScheduledToDepart: {
    id: 'fastCover.stepWhatHappened.dateScheduledToDepart',
    defaultMessage: 'Date I was originally scheduled to depart on my trip',
  },
  dateOriginallyScheduled: {
    id: 'fastCover.stepWhatHappened.dateOriginallyScheduled',
    defaultMessage: 'Date I was originally scheduled to return home',
  },
  benefitInstruction: {
    id: 'fastCover.stepWhatHappened.benefitInstruction',
    defaultMessage: 'Why are you submitting the claim? Select all that apply',
  },
  benefitInstructionSCTI: {
    id: 'fastCover.stepWhatHappened.benefitInstructionSCTI',
    defaultMessage: 'What are you claiming for? Select all that apply.',
  },
  storyEventSCTI: {
    id: 'fastCover.stepWhatHappened.storyEventSCTI',
    defaultMessage: 'Please describe what happened.',
  },
  policyVersionChangeWarning: {
    id: 'fastCover.stepWhatHappened.policyVersionChangeWarning',
    defaultMessage: 'Proceeding with update to event date will empty the claim form and all details will have to be re-entered as the new event date falls in the period of different policy version. Do you want to proceed with event date change?',
  },
  claimFor: {
    id: 'fastCover.stepWhatHappened.insureds',
    defaultMessage: 'This claim is being created for',
  },
  claimForTooltip: {
    id: 'fastCover.stepWhatHappened.insuredsTooltip',
    defaultMessage: 'Please select all travelers you wish to make a claim for.',
  },
  whatAreYouClaimingFor: {
    id: 'fastCover.stepWhatHappened.insuredsTooltip',
    defaultMessage: 'What are you claiming for? Pick only one Qualifying Hardship.',
  },
  whatIsTheOutstandingDuesAmount: {
    id: 'fastCover.stepWhatHappened.whatIsTheOutstandingDuesAmount',
    defaultMessage: 'What is the outstanding Dues Amount',
  },
  currency: {
    id: 'fastCover.stepWhatHappened.currency',
    defaultMessage: 'Currency',
  },
  nameOfTheTourOperator: {
    id: 'fastCover.stepWhatHappened.nameOfTheTourOperator',
    defaultMessage: 'Name of the Tour Operator / Agent you were traveling with:',
  },
  address: {
    id: 'fastCover.stepWhatHappened.address',
    defaultMessage: 'Address',
  },
  cityOrTown: {
    id: 'fastCover.stepWhatHappened.cityOrTown',
    defaultMessage: 'City or Town',
  },
  postalCode: {
    id: 'fastCover.stepWhatHappened.postalCode',
    defaultMessage: 'Postal Code',
  },
  contact: {
    id: 'fastCover.stepWhatHappened.contact',
    defaultMessage: 'Contact',
  },
  phoneNumber: {
    id: 'fastCover.stepWhatHappened.phoneNumber',
    defaultMessage: 'Phone Number',
  },
  bookingReservationNumber: {
    id: 'fastCover.stepWhatHappened.bookingReservationNumber',
    defaultMessage: 'Booking reservation number',
  },
  destinations: {
    id: 'fastCover.stepWhatHappened.destinations',
    defaultMessage: 'Destination(s)',
  },
  cityOfDeparture: {
    id: 'fastCover.stepWhatHappened.cityOfDeparture',
    defaultMessage: 'City of departure',
  },
  returnDestination: {
    id: 'fastCover.stepWhatHappened.returnDestination',
    defaultMessage: 'Return destination',
  },
  dateOfInitialPaymentDesposit: {
    id: 'fastCover.stepWhatHappened.dateOfInitialPaymentDesposit',
    defaultMessage: 'Date Of Initial Payment Deposit',
  },
  ifNotIncludedInThePackage: {
    id: 'fastCover.stepWhatHappened.ifNotIncludedInThePackage',
    defaultMessage: 'If not included in the package, how was the travel arranged?',
  },
  usePrimaryMemberEmailAddressForAllMember: {
    id: 'fastCover.stepWhatHappened.usePrimaryMemberEmailAddressForAllMember',
    defaultMessage: 'Use primary member email address for all members',
  },
  usePrimaryMemberPhoneNumberForAllMember: {
    id: 'fastCover.stepWhatHappened.usePrimaryMemberPhoneNumberForAllMember',
    defaultMessage: 'Use primary member phone number for all members',
  },
  name: {
    id: 'fastCover.stepWhatHappened.name',
    defaultMessage: 'Name',
  },
  email: {
    id: 'fastCover.stepWhatHappened.email',
    defaultMessage: 'Email (for future claim correspondence)',
  },
  isValid: {
    id: 'fastCover.stepClaimSummary.isValid',
    defaultMessage: "'{defaultMessage}' is invalid",
  },
  policyPurchaseDate: {
    id: 'fastCover.stepWhatHappened.policyPurchaseDate',
    defaultMessage: 'Policy Purchase Date',
  },
  policyEffectiveDate: {
    id: 'fastCover.stepWhatHappened.policyEffectiveDate',
    defaultMessage: 'Policy Effective Date',
  },
  policyTerminationDate: {
    id: 'fastCover.stepWhatHappened.policyTerminationDate',
    defaultMessage: 'Policy Termination Date',
  },
  purposeOfTrip: {
    id: 'fastCover.stepWhatHappened.PurposeOfTrip',
    defaultMessage: 'Purpose of Trip',
  },
  holiday: {
    id: 'fastCover.stepWhatHappened.holiday',
    defaultMessage: 'Holiday',
  },
  business: {
    id: 'fastCover.stepWhatHappened.business',
    defaultMessage: 'Business',
  },
  medical: {
    id: 'fastCover.stepWhatHappened.medical',
    defaultMessage: 'Medical',
  },
  study: {
    id: 'fastCover.stepWhatHappened.study',
    defaultMessage: 'Study',
  },
  other: {
    id: 'fastCover.stepWhatHappened.other',
    defaultMessage: 'Other',
  },
  dateOfEventTooltipContent: {
    id: 'fastCover.stepWhatHappened.dateOfEventTooltipContent',
    defaultMessage: 'Date that the incident occurred.',
  },
  dateOfEventTooltipContentVTC: {
    id: 'fastCover.stepWhatHappened.dateOfEventTooltipContentVTC',
    defaultMessage: 'Date of your injury, or the first date you saw a provider about your illness.',
  },
  timeOfEventTooltipContent: {
    id: 'fastCover.stepWhatHappened.timeOfEventTooltipContent',
    defaultMessage: 'timeOfEventTooltipContent',
  },
  dateSymptomsStarted: {
    id: 'fastCover.stepWhatHappened.dateSymptomsStarted',
    defaultMessage: 'If illness, Date you first started experiencing symptoms.',
  },
  province: {
    id: 'fastCover.stepWhatHappened.province',
    defaultMessage: 'Province',
  },
  cityTooltipContent: {
    id: 'fastCover.stepWhatHappened.cityTooltipContent',
    defaultMessage: 'cityTooltipContent',
  },
  typeACity: {
    id: 'fastCover.stepWhatHappened.typeACity',
    defaultMessage: 'typeACity',
  },
  onlyOneEventText: {
    id: 'fastCover.stepWhatHappened.onlyOneEventText',
    defaultMessage: 'Only One Event',
  },
  onlyOneEventTextVTC: {
    id: 'fastCover.stepWhatHappened.onlyOneEventTextVTC',
    defaultMessage: 'Only one event can be assigned to a claim. If claiming for multiple events, please submit one claim for each incident.',
  },
  eventInstructionNote: {
    id: 'fastCover.stepWhatHappened.eventInstructionNote',
    defaultMessage: 'An Event is a unique Incident that caused your claim.',
  },
  eventInstructionTitle: {
    id: 'fastCover.stepWhatHappened.eventInstructionTitle',
    defaultMessage: 'Tell us about the Event that caused your claim.',
  },
  eventInstructionExampleOne: {
    id: 'fastCover.stepWhatHappened.eventInstructionExampleOne',
    defaultMessage: 'e.g. Event 1 - Whilst on your trip, your airline cancelled a flight.',
  },
  eventInstructionExampleTwo: {
    id: 'fastCover.stepWhatHappened.eventInstructionExampleTwo',
    defaultMessage: 'e.g. Event 2 - A week later you injured yourself getting off a bus.',
  },
  eventInstructionIncludeExpenses: {
    id: 'fastCover.stepWhatHappened.eventInstructionIncludeExpenses',
    defaultMessage: 'For each Event include ALL your expenses related to that Event.',
  },
  eventInstructionSeparateClaim: {
    id: 'fastCover.stepWhatHappened.eventInstructionSeparateClaim',
    defaultMessage: 'If you had more than one Event, create a separate Claim for each Event.',
  },
  noteLabel: {
    id: 'fastCover.stepWhatHappened.noteLabel',
    defaultMessage: 'Note:',
  },
  paymentInformationNote: {
    id: 'fastCover.stepWhatHappened.paymentInformationNote',
    defaultMessage: 'The primary claimant payment details will be used for all members you select for this claim. If you need any member to be paid to a different bank account, please go back to the Claim List screen and create a separate claim for this member.',
  },
  youMustEnterEvent: {
    id: 'fastCover.stepWhatHappened.youMustEnterEvent',
    defaultMessage: 'You must enter event date and time to continue.',
  },
  clickingEachTileBelowWillOpenANewTabToComplete: {
    id: 'fastCover.stepWhatHappened.clickingEachTileBelowWillOpenANewTabToComplete',
    defaultMessage: 'Clicking each tile below will open a new tab to complete. To see what each tile means, click the information icon',
  },
  eventDescriptionMaxLength: {
    id: 'fastCover.stepWhatHappened.eventDescriptionMaxLength',
    defaultMessage: 'The event description exceeds the maximum limit of {maxEventLength} characters.',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepWhatHappened/messages.js